import { render, staticRenderFns } from "./EditarSocio.vue?vue&type=template&id=2f6c4e3c&scoped=true&"
import script from "./EditarSocio.vue?vue&type=script&lang=js&"
export * from "./EditarSocio.vue?vue&type=script&lang=js&"
import style0 from "./EditarSocio.vue?vue&type=style&index=0&id=2f6c4e3c&prod&lang=css&"
import style1 from "./EditarSocio.vue?vue&type=style&index=1&id=2f6c4e3c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6c4e3c",
  null
  
)

export default component.exports